<template>
  <div :id="id" :class="className" :style="{height:height,width:width}"/>
</template>

<script>
import echarts from 'echarts'
import resize from "@/components/Charts/mixins/resize";
import { ls3ChartFont } from '@/utils/ls3ChartCompact'


export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    path: {
      type: String
    },
    params: {}
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  watch: {
    '$route': function (to, from) {
      if (to != from) {
        this.initChart();
      }
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById(this.id), 'dark')

      var post_params = Object.assign({}, {"extra_params": this.params});
      this.$http.post(process.env.VUE_APP_API_HOST + "/" + this.path, post_params, {"content-type": "application/json"}).then((res) => {

        let indicators = []
        let values = []
        const max_val = res.data.data.reduce((prev, current) => (parseInt(prev.value) > parseInt(current.value)) ? prev : current)
        console.log('max_val:' + max_val.value)
        for (const obj of res.data.data) {
          indicators.push({text: obj['name'], max: 1.1 * parseInt(max_val.value)});
          values.push(obj['value'])
        }

        const f = ls3ChartFont
        this.chart.setOption({
          // color: ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"],
          color: ["#FC953B", "#F5E447", "#608FFC", "#1CA6FF", "#60FCB2", "#7EFC60"],
          backgroundColor: "#080A20",
          tooltip: {
            trigger: 'axis'
          },
          toolbox: {
            show: true,
            feature: {
              saveAsImage: {show: true},
              myTool1: {
                show: true,
                title: '全屏',
                icon: "path://M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z",
                onclick: () => {
                  const element = document.getElementById(this.id);
                  if (element.requestFullScreen) { // HTML W3C 提议
                    element.requestFullScreen();
                  } else if (element.msRequestFullscreen) { // IE11
                    element.msRequestFullScreen();
                  } else if (element.webkitRequestFullScreen) { // Webkit (works in Safari5.1 and Chrome 15)
                    element.webkitRequestFullScreen();
                  } else if (element.mozRequestFullScreen) { // Firefox (works in nightly)
                    element.mozRequestFullScreen();
                  }
                  // 退出全屏
                  if (element.requestFullScreen) {
                    document.exitFullscreen();
                  } else if (element.msRequestFullScreen) {
                    document.msExitFullscreen();
                  } else if (element.webkitRequestFullScreen) {
                    document.webkitCancelFullScreen();
                  } else if (element.mozRequestFullScreen) {
                    document.mozCancelFullScreen();
                  }
                },
              }
            }
          },
          // label: {normal: {overflow: 'none'}},
          title: {
            text: res.data.title ? res.data.title : "",
            textStyle: { fontSize: f(14) },
          },
          textStyle: {
            fontSize: f(18)
          },
          radar: {
            shape: 'circle',
            indicator: indicators,
            name: {
              textStyle: {
                fontSize: f(12),
                color: '#ccc'
              }
            },
            // center: ['25%', '40%'],
            // radius: 80,
            splitArea: {
              show: true,
              areaStyle: {
                // color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4']
                color: ["#FC953B", "#F5E447", "#608FFC", "#1CA6FF", "#60FCB2", "#7EFC60"],
                // 图表背景网格的颜色
              }
            },

            // splitLine: {
            //   show: true,
            //   lineStyle: {
            //     width: 1,
            //     color: ['#7954a1', '#ef91ab']
            //     // 图表背景网格线的颜色
            //   }
            // },
            // axisName: {
            //   color: '#fff',
            //   backgroundColor: '#666',
            //   borderRadius: 3,
            //   padding: [3, 5]
            // },

          },
          legend: {
            data: ['患病统计'],
            textStyle: { fontSize: f(12) }
          },
          series: [
            {
              // name: res.data.name,
              tooltip: {
                trigger: 'item'
              },
              areaStyle: {},
              type: 'radar',
              // axisName: {
              //   color: 'rgb(238, 197, 102)'
              // },
              // min: 0,
              // max: 100,
              data: [
                {
                  value: values,
                  lineStyle: {
                    type: 'dashed'
                  },
                  label: {
                    show: true,
                    fontSize: f(11),
                    formatter: function (params) {
                      return params.value;
                    }
                  },
                  areaStyle: {
                    // color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    //   {
                    //     color: 'rgba(255, 145, 124, 0.1)',
                    //     offset: 0
                    //   },
                    //   {
                    //     color: 'rgba(255, 145, 124, 0.9)',
                    //     offset: 1
                    //   }
                    // ])
                  },

                  name: "病种收入（元）"
                }]
            }
          ]
        })
      })
    }
  }
}
</script>
